document.addEventListener("DOMContentLoaded", function () {
  // Obtener elementos
  const videoSection = document.querySelector(".background-video-section");
  const body = document.body;

  // Ajustar la altura del video para que ocupe el 100% del viewport menos el header
  function adjustVideoHeight() {
    const header = document.querySelector(".site-control.nav-inline-desktop");
    if (header && videoSection) {
      const headerHeight = header.offsetHeight;
      videoSection.style.height = `calc(100vh - ${headerHeight}px)`;
    }
  }

  // Click para avanzar al último frame
  const section = document.querySelector(".background-video-section");
  if (section) {
    const clickToEndEnabled = section.dataset.clickToEnd === "true";

    if (clickToEndEnabled) {
      const videos = section.querySelectorAll("video");

      videos.forEach((video) => {
        let hasEnded = false; // Bandera para rastrear si el video ha terminado

        // Actualizar estado cuando el video termine naturalmente
        video.addEventListener("ended", () => {
          hasEnded = true;
        });

        const handleClick = (e) => {
          if (hasEnded) return; // No hacer nada si el video ya ha terminado
          e.preventDefault();
          e.stopPropagation();

          if (video.duration && isFinite(video.duration)) {
            video.currentTime = video.duration;
            video.pause();
            hasEnded = true; // Marcar como terminado manualmente
          } else {
            video.addEventListener(
              "loadedmetadata",
              () => {
                video.currentTime = video.duration;
                video.pause();
                hasEnded = true; // Marcar como terminado después de cargar
              },
              { once: true }
            );
          }
        };

        video.addEventListener("click", handleClick);
        video.addEventListener("touchstart", handleClick);
      });
    }
  }
});
